'use client'

import { useEffect } from 'react'
import { addRecentlyViewedCategory } from '@/app/_lib/services/RecentlyViewedService'

/**
 * Tracks category views via Route Handler instead of Server Action.
 * Uses sendBeacon for fire-and-forget tracking that doesn't block navigation.
 * This avoids RSC errors when bots render pages with JS enabled.
 */
const CategoryViewTracker = ({ category }) => {
    const category_id = category?.category_id
    const layout_type = category?.layout_type

    useEffect(() => {
        if (category_id) {
            addRecentlyViewedCategory(category)
            const payload = JSON.stringify({
                event: 'CATEGORY:VIEW',
                data: { category_id, category_type: layout_type }
            })
            navigator.sendBeacon('/api/track', payload)
        }
    }, [category, category_id, layout_type])

    return null
}

export default CategoryViewTracker
